<template>
  <Modal class="rtp-modal" v-model="modalStatus" :footer-hide="showStatus">
    <div v-if="!type" slot="header" class="tc mt-4">
      <h3>{{ rtpGameName }}</h3>
    </div>
    <table v-if="!type" class="TB_COLLAPSE" style="width: 100%;">
      <thead>
        <tr>
          <th>目标RTP</th>
          <th>启用RTP</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <Input v-model="target" style="width: 90%;"></Input>
          </td>
          <td>
            <RadioGroup v-model="isrtp">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!type" class="mt-3 ml-3" style="color: #f00;">
      <h4>*设定范围：70％～105％</h4>
    </div>
    <div v-if="type">
      <p class="bold red-text">注：以下设定隔日起生效</p>
      <Form ref="form" :rules="formRule">
        <FormItem label="RTP计算方式" prop="type">
          <RadioGroup v-model="form.type">
            <Radio label="2" :disabled="showStatus">每日计算</Radio>
            <Radio label="1" :disabled="showStatus">累计计算</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="每日重至时间" prop="time" v-if="form.type == 2">
          <TimePicker
            v-model="form.time"
            format="HH点mm分ss秒"
            placeholder="輸入每日重至时间"
            style="width: 168px"
            :steps="[1, 10]"
            :disabled-seconds="disabledNum"
            :disabled="showStatus"
          ></TimePicker>
        </FormItem>
      </Form>
    </div>
    <div slot="footer" class="mb-2 mt-2">
      <Button type="primary" @click="modalStatus = false">取消</Button>
      <Button type="error" @click="update">更新</Button>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RtpModifyModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    rtpGameName: {
      type: String,
      default: ''
    },
    targetRtp: {
      type: Number,
      default: 0
    },
    isRTP: Number,
    gameid: Number,
    type: Boolean
  },
  data () {
    return {
      target: 0,
      form: {
        type: 1,
        time: '22:00:00'
      },
      formRule: {
        type: [
          { required: true, message: ' ' }
        ]
      },
      isrtp: 1
    }
  },
  computed: {
    ...mapGetters(['getmember', 'getpermission']),
    modalStatus: {
      get () {
        this.target = this.targetRtp
        this.isrtp = this.isRTP
        return this.showModal
      },
      set (val) {
        this.$emit('update:type', val)
        this.$emit('update:showModal', val)
      }
    },
    disabledNum () {
      let arr = []
      for (let i = 1; i < 60; i++) {
        arr.push(i)
      }
      return arr
    },
    showStatus () {
      return this.getpermission.gameset[1] == 0
    }
  },
  watch: {
    type (val) {
      if (val) this.getSet()
    }
  },
  methods: {
    async update () {
      const rule = /^[0-9]+.?[0-9]*/
      if (!this.type && !rule.test(this.target)) return this.$Message.error('请输入范围内的数值')
      if (!this.type && (this.target < 70 || this.target > 105)) return this.$Message.error('超出范围')
      if (!/^[0-9]*$/.test(this.target)) return this.$Message.error('请输入整數')
      try {
        let res
        if (!this.type) res = await this.$axios.gameLobby.gamertpupd({ loid: this.getmember.pid, gameid: this.gameid, newrtp: this.target, isrtp: this.isrtp })
        if (this.type) {
          const misve = [
            { RTPSetId: 1, setValue: Number(this.form.type)},
            { RTPSetId: 2, setValue: Number(this.form.time.substring(0, 2)) },
            { RTPSetId: 3, setValue: Number(this.form.time.substring(3, 5)) }
          ]
          const data = {
            loid: this.getmember.pid,
            misve
          }
          res = await this.$axios.gameLobby.RTPSetUpd(data)
        }
        if (res.status != 1) return
        this.$Message.success('修改成功')
        this.$emit('getData')
        this.modalStatus = false
      } catch (error) {
        console.error(error)
      }
    },
    async getSet () {
      try {
        let res = await this.$axios.gameLobby.RTPSetList()
        if ('status' in res && res.status === 0) return
        let hour = res[1].setValue < 10 ? `0${res[1].setValue}` : res[1].setValue
        let minutes = res[2].setValue < 10 ? `0${res[2].setValue}` : res[2].setValue
        this.form.type = String(res[0].setValue)
        this.form.time = `${hour}:${minutes}:00`
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss">
.rtp-modal .ivu-modal {
  width: 22% !important;
  .ivu-form {
    .ivu-form-item {
      margin-bottom: 0;
    }
  }
}
</style>